import { Box, Text, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/i18n';
import React, { useState } from 'react';
export const FailedElementItem = _ref => {
  let {
    displayName,
    onViewClick,
    dataHook
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHook,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false)
  }, /*#__PURE__*/React.createElement(Box, {
    align: "space-between",
    backgroundColor: isHovered ? '#F4F7FF' : 'white',
    border: "1px solid",
    borderColor: isHovered ? '#116DFF' : '#D6E6FE',
    borderRadius: "6px",
    cursor: onViewClick ? 'pointer' : 'default',
    direction: "horizontal",
    marginBottom: "SP1",
    padding: "9px 12px",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    secondary: true,
    onClick: onViewClick
  }, displayName), isHovered && onViewClick && /*#__PURE__*/React.createElement(TextButton, {
    size: "tiny",
    onClick: e => {
      e.stopPropagation();
      onViewClick();
    }
  }, t('accessibility-wizard.rules-list.page-auto-dom-order.failed-element-item.view'))));
};
//# sourceMappingURL=failed-element-item.js.map